import { Component, OnInit } from '@angular/core';
import { CustomerBillingInvoiceModel } from '../customer-billing-invoice.model';
import { InvoiceService } from '../invoice.service';
import { LoadingService } from '@fi-shared/fi-loading/loading.service';
import { FiDialogsContentBase } from '@fi-shared/fi-dialogs/fi-dialogs-content-base';
import { FiDialogCloseReason } from '@fi-shared/fi-dialogs/fi-dialogs-close-reason';

@Component({
    selector: 'fi-customer-billing-invoice-edit-dialog',
    templateUrl: './customer-billing-invoice-edit-dialog.component.html',
    styleUrls: ['./customer-billing-invoice-edit-dialog.component.scss'],
    standalone: false,
})
export class CustomerBillingInvoiceEditDialogComponent
    extends FiDialogsContentBase<CustomerBillingInvoiceModel, boolean>
    implements OnInit
{
    private invoiceService: InvoiceService;
    private fiLoadingService: LoadingService;

    ngOnInit() {
        this.invoiceService = this.injector.get(InvoiceService);
        this.fiLoadingService = this.injector.get(LoadingService);
    }

    // note: not used ?
    updateCustomerInfo() {}

    saveInvoice() {
        const promise = this.invoiceService.SaveInvoice(this.data);
        this.fiLoadingService.trackPromise(promise);
        promise.then((Id) => {
            this.data.Id = Id;
            this.dialogRef.close({
                value: true,
                reason: FiDialogCloseReason.YesButton,
            });
        });
    }
}
